/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */

const PrettyPrintJson = ({ data }) => {
    return (
        <div>
            <pre>{JSON.stringify(data, null, 2)}</pre>
        </div>
    );
};

export default PrettyPrintJson;
